const stripDirectoryPrefix = (name = "", directoryName = "") => {
  if (!name || !directoryName) return name || "";
  const prefix = `${directoryName}-`;
  if (name.startsWith(prefix)) {
    return name.slice(prefix.length);
  }
  return name;
};

const buildFromLegacy = (fileNames = "", directoryName = "") => {
  if (!fileNames) return [];
  return fileNames
    .split(",")
    .map((rawName) => rawName.trim())
    .filter(Boolean)
    .map((name, index) => {
      const displayName = stripDirectoryPrefix(name, directoryName);
      return {
        id: `${directoryName || "legacy"}-${index}`,
        originalName: name,
        displayName,
        sizeBytes: null,
        legacy: true,
      };
    });
};

const buildFromDto = (files = [], directoryName = "") => {
  return (files || []).map((file, index) => {
    const originalName = file?.originalName || file?.name || "";
    const displayName = stripDirectoryPrefix(originalName, directoryName);
    return {
      ...file,
      id: file?.id || file?.storageKey || `${directoryName || "file"}-${index}`,
      originalName,
      displayName,
      sizeBytes: typeof file?.sizeBytes === "number" ? file.sizeBytes : file?.size ?? null,
      legacy: false,
    };
  });
};

export const normalizeSourceFiles = (upload = {}) => {
  const { sourceFiles, fileNames, directoryName } = upload || {};
  if (Array.isArray(sourceFiles) && sourceFiles.length > 0) {
    return buildFromDto(sourceFiles, directoryName);
  }
  if (typeof fileNames === "string" && fileNames.trim()) {
    return buildFromLegacy(fileNames, directoryName);
  }
  return [];
};

export default normalizeSourceFiles;

